import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format checker-namen leesbaar: voeg een spatie toe vóór "Check" en bij
 * CamelCase-grenzen. Bv. "HuurCheck" → "Huur Check", "AppPrivacyCheck" → "App Privacy Check".
 */
export function formatCheckerName(name) {
  if (!name || typeof name !== "string") return name;
  // Insert space before each uppercase letter that follows a lowercase letter
  return name.replace(/([a-z])([A-Z])/g, "$1 $2");
}
